import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import React, { memo } from 'react'

import styles from './TaskRow.module.sass'

const TaskRow = memo(
	(props) => {
		const { data, className, ...attributes } = props
		const { gotoProcess, cancelTask } = useGlobal()

		const taskOptions = [
			{
				value: 'seeProcess',
				text: data.rowLabels.seeProcess,
				action: () => gotoProcess(data.processId),
			},
			{
				value: 'cancel',
				text: data.rowLabels.cancel,
				action: () => cancelTask(data),
			},
		]

		return (
			<div
				{...attributes}
				className={`${styles['row'] || ''} ${className || ''} ${
					data.editing ? styles['is-active'] || '' : ''
				}`}
			>
				<span className={styles['icon-cell']}>
					<span className={styles['icon-container']}>
						<Icon
							className={styles['icon']}
							height='20px'
							width='20px'
							name={data.icon}
						/>
					</span>
				</span>
				<span className={styles['details']}>
					<div>
						<h5>
							{data.segment?.abbreviation} -{' '}
							{data.insuranceCompany?.shortName}{' '}
							{data.injured?.name && (
								<small>
									<strong>({data.injured?.name})</strong>
								</small>
							)}
						</h5>
						<small>{data.title}</small>
					</div>
				</span>
				<span className={styles['process']}>
					<div>
						{data?.processId && <h5>#{data?.processId}</h5>}
						{data?.requisitionId && (
							<small>#{data?.processId}</small>
						)}
					</div>
				</span>

				<span>
					<div>{data?.createdAt && <h5>{data?.createdAt}</h5>}</div>
				</span>

				<div className={styles['options']}>
					<span
						className={`${styles[data.priority.name]} ${
							styles['priority']
						}`}
					>
						<Tooltip text={data.rowLabels[data.priority.name]}>
							<Icon
								className={styles['icon']}
								name={data.priority.name}
								height='24px'
								width='24px'
							/>
						</Tooltip>
					</span>
					<ModalOptions
						options={taskOptions}
						title={data.rowLabels.options}
						onSelect={(item, e) => {
							item && item.action && item.action()
						}}
					>
						<ActionButton
							className={styles['action-button']}
							icon='options'
						/>
					</ModalOptions>
				</div>
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.style.top === nextProps.style.top
)

export const TaskRowSkeleton = (props) => {
	const { className, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['row-skeleton']} ${className || ''}`}
		>
			<span className={styles['icon']}>
				<Skeleton className={styles['skeleton']} />
			</span>
			<span>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['smaller']}`}
					/>
				</h5>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
			<span className={styles['process']}>
				<small>
					<Skeleton className={styles['skeleton']} />
				</small>
			</span>
			<span>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
		</div>
	)
}

export const TaskListHeader = (props) => {
	const { i18n } = useGlobal()
	return (
		<div className={`${styles['header']} ${props.className || ''}`}>
			<span className={styles['icon-cell']}></span>
			<span className={styles['details']}>
				<div>
					<h5>
						{i18n`Segment`} - {i18n`Insurance Company`}{' '}
						<small>
							<strong>({i18n`Injured Name`})</strong>
						</small>
					</h5>
					<small>{i18n`Task Type`}</small>
				</div>
			</span>
			<span className={styles['process']}>
				<div>
					<h5>#{i18n`Process Id`}</h5>
					<small>#{i18n`Requisition Id`}</small>
				</div>
			</span>
			<span>
				<div>
					<h5>{i18n`Task date`}</h5>
					<small>{i18n`Task date`}</small>
				</div>
			</span>
			<div className={styles['options']}>
				<h5>{i18n`Priority`}</h5>
				<h5>{i18n`Options`}</h5>
			</div>
		</div>
	)
}

export default TaskRow
